module.exports = __webpack_public_path__ + "static/Mich-tablet-32943529ec4920317b15bd425cb3c65b.jpg";